import { render, staticRenderFns } from "./AuthFactor.html?vue&type=template&id=3a484318&scoped=true&"
import script from "./AuthFactor.vue?vue&type=script&lang=js&"
export * from "./AuthFactor.vue?vue&type=script&lang=js&"
import style0 from "./AuthFactor.scss?vue&type=style&index=0&id=3a484318&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a484318",
  null
  
)

export default component.exports